<script setup>
useCustomMeta('top')
const breadCrumbList = getBreadCrumb()
const { data: mapPosition } = await useFetch('/api/kosa/mapConfig', { query: { path: 'japan' } })
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <KosaMap :map-position="mapPosition" />
      </div>
      <template #main-bottom>
        <LivecamList area="japan" />
        <KosaAreaList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.satellite {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .slider {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    .content {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-top: 20px;
  }
  .box {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 10px;
    background-color: #eef1f8;
  }
}
.main {
  .satellite {
    @media screen and (min-width: 830px) {
      .box {
        padding-inline: 15px;
      }
    }
  }
}
</style>
